import React, {Component} from "react";

import axios from 'axios';
import Constants from '../../../components/Constants/';
import {
    Row,
    Col,
    Button,
    Label,
    Input,
    Link,
    Table,
    Badge
} from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import AlertContainer from 'react-alert';

class Category extends Component {

  constructor(props) {
    super(props);

    this.refreshCategoryList = this.refreshCategoryList.bind(this);
    this.afterSaveCell = this.afterSaveCell.bind(this);
    this.onAddCategory = this.onAddCategory.bind(this);
    this.normalDiagFormatter = this.normalDiagFormatter.bind(this);
    this.onRowClick = this.onRowClick.bind(this);

    this.state = {
        categoryList: null,
        activePage: 1,
        diags: null,
        diagnosticsList: null,
        selectableDiags: null
      };

      /*
      * Configurações do alerta
      */
      this.alertOptions = {
        offset: 14,
        position: 'top right',
        theme: 'light',
        time: 10000,
        transition: 'scale'
      }

      //Diagnósticos
      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/diagnostic'
      })
      .then(response => {
        let diagnosticsList = [];
        response.data.forEach(function(diag) {
          if(diag.category){
            if( ! diagnosticsList[diag.category.id] )  diagnosticsList[diag.category.id] = [];
            diagnosticsList[diag.category.id].push(
              {
                value: diag.id,
                text: diag.description
              }
            );
          }
        });

        this.setState({
            diags: response.data,
            diagnosticsList: diagnosticsList
        });
      });

      this.refreshCategoryList();
    }

    refreshCategoryList(){
      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/category'
      })
      .then(response => {
          this.setState({
              categoryList: response.data
          });
      });
    }

    statusFormatter(cell, row){
      return (
        cell == "ACTIVE" ? <Badge color="success">Ativo</Badge> : <Badge color="danger">Inativo</Badge>
      );
    }

    multiDiagFormatter(cell, row){
      return (
        cell == true || cell == 'true' ? <Badge color="success">Sim</Badge> : <Badge color="danger">Não</Badge>
      );
    }



    actionsFormatter(cell, row){
      return (
        <Button color="info" onClick={() => { alert(cell); }}><i className="fa fa-pencil"></i></Button>
      );
    }

    normalDiagFormatter(cell, row){
      let txt = " - ";
      this.state.diags.forEach(function(diag) {
        if(diag.id === cell){
          txt = diag.description;
        }
      });

      return (txt);
    }

    renderPaginationShowsTotal(start, to, total) {
      return (
        <p>
          Exibindo de { start } a { to }, total: { total }
        </p>
      );
    }

    afterSaveCell(row, cellName, cellValue) {
      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/category',
          data: row
      })
      .then(response => {
        this.msg.show('Categoria salva.', {
          time: 10000,
          type: 'success'
        });
      });
    }

    onAddCategory(row) {

      row.id = null;
      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/category',
          data: row
      })
      .then(response => {
          this.msg.show('Categoria adicionado.', {
            time: 10000,
            type: 'success'
          });
          this.refreshCategoryList();
      });
    }

    createCustomModalHeader(closeModal, save){
      return (
        <InsertModalHeader
          className='model-header'
          title=''
         />
      );
    }

    onRowClick(row) {
      //JSON.parse é uma maneira de clonar um objeto não mantendo a sua referencia.
      //Refatorar
      let selectableDiags = JSON.parse(JSON.stringify(this.state.diagnosticsList[row.id]));

      selectableDiags.push({
        value: null,
        text: ""
      });

      this.setState({
        selectableDiags: selectableDiags
      });
    }


    render() {
      if(this.state.categoryList == null) return null;
      if(this.state.diags == null) return null;

      const tableOptions = {
        paginationSize: 10,
        hideSizePerPage: true,
        paginationShowsTotal: true,
        paginationShowsTotal: this.renderPaginationShowsTotal,
        onAddRow: this.onAddCategory,
        insertModalHeader: this.createCustomModalHeader,
        onRowClick: this.onRowClick
      };

      const statusTypes = [ {
        value: 'ACTIVE',
        text: 'Ativo'
      }, {
        value: 'INACTIVE',
        text: 'Inativo'
      }];

      const allowMultipleDiagTypes = [ {
        value: true,
        text: 'Sim'
      }, {
        value: false,
        text: 'Não'
      }];

      const cellEdit = {
        mode: 'dbclick',
        blurToSave: true,
        afterSaveCell: this.afterSaveCell,
      };

      return(
          <div>
            <h2>Categorias</h2>
            <hr />
            <BootstrapTable ref="table" data={this.state.categoryList} version='4'
              striped hover pagination insertRow search searchPlaceholder='Pesquisa Geral'
              options={tableOptions} cellEdit={ cellEdit }>
              <TableHeaderColumn dataField="description" dataSort={true} width='20%'>Descrição</TableHeaderColumn>
              <TableHeaderColumn dataField="status" editable={ { type: 'select', options: { values: statusTypes } } } dataFormat={this.statusFormatter} dataSort={true} width='20%'>Status</TableHeaderColumn>
              <TableHeaderColumn dataField="normalDiagId" editable={ { type: 'select', options: { values: this.state.selectableDiags } } } dataFormat={this.normalDiagFormatter} dataSort={true} width='20%'>Diag. Normal</TableHeaderColumn>

              <TableHeaderColumn dataField="order" dataSort={true} width='10%'>Ordem</TableHeaderColumn>
              <TableHeaderColumn dataField="allowMultipleDiag" editable={ { type: 'checkbox', options: { values: 'true:false' } } } dataFormat={this.multiDiagFormatter} dataSort={true} width='10%'>Diag. Mult.</TableHeaderColumn>

              <TableHeaderColumn dataField="id" autoValue isKey={true} width='20%'>ID</TableHeaderColumn>

            </BootstrapTable>
            <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />
            <br />
          </div>
        )
    }
}

export default Category;



// WEBPACK FOOTER //
// ./src/views/admin/Category/Category.js